import {Component, Input, OnInit} from '@angular/core';
import {AttachmentService} from "../../../services/attachment.service";

@Component({
    selector: 'app-makery-event-base',
    templateUrl: './makery-event-base.component.html',
    styleUrls: ['./makery-event-base.component.scss']
})
export class MakeryEventBaseComponent implements OnInit {

    @Input() event;
    @Input() selectedLanguage;

    constructor(private attachmentService: AttachmentService) {
    }

    ngOnInit() {
        Object.values<any>(this.event.eventBase.attachments).forEach(prodAttachment => {
            this.attachmentService.addExtraDataForOne(prodAttachment.attachment);
        });
    }

}
